import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "alert" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    d: "M11.9311 9.99975V11.9998V9.99975ZM11.9311 15.9998H11.9411H11.9311ZM5.00308 19.9998H18.8591C20.3991 19.9998 21.3611 18.3328 20.5911 16.9998L13.6631 4.99975C12.8931 3.66675 10.9691 3.66675 10.1991 4.99975L3.27108 16.9998C2.50108 18.3328 3.46308 19.9998 5.00308 19.9998Z",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }